import React, {FormEvent, useRef, useState} from "react";

import {updatePassword} from "../../api/auth-api";
import {AxiosError} from "axios";
import {useLocation} from "react-router-dom";
import Form from "react-bootstrap/Form";
import {Alert, Button} from "react-bootstrap";
import {Page} from "../../common/Page";

export const SetPasswordPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<AxiosError | null>(null);
  const passwordField = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (token === null) {
      return;
    }
    setError(null);
    setSubmitting(true);
    updatePassword({password, token})
      .then(() => {
          setSubmitting(false);
          setSubmitted(true);
        },
        (error: AxiosError) => {
          setSubmitting(false);
          setError(error);
        })
  };

  return (
    <Page title={"Set your password"}>
      {token === null && <Alert variant={"danger"} className={'mb-3'}>
        <Alert.Heading>Broken link</Alert.Heading>
        <p>The link you used is broken. Please try again.</p>
      </Alert>}
      {token !== null && (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="setPassword.password">
            <Form.Label>Password</Form.Label>
            <Form.Control ref={passwordField}
                          type="password"
                          placeholder=""
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          disabled={submitting || submitted}
                          minLength={8} maxLength={72}
                          required
                          autoFocus={true}
            />
          </Form.Group>
          <Button type={'submit'} variant={'primary'} className={'mb-3'} disabled={submitting || submitted}>Set
            password</Button>
          {error && <Alert variant={"danger"} className={'mb-3'}>
            <Alert.Heading>Setting password failed</Alert.Heading>
            <p>Make sure your password is suitable and try again.</p>
            <p>This link expires after 1 hour. To request another link, please <a href={'/create-account'}>create your
              account</a> again.</p>
          </Alert>}
          {submitted && <Alert variant={"success"} className={'mb-3'}>
            <Alert.Heading>Password set</Alert.Heading>
            <p>Your password has been set. You can now <a href={'/login'}>log in</a> with it.</p>
          </Alert>}

          <Alert variant={"light"} className="mt-4">
            <Alert.Heading>Password rules</Alert.Heading>
            <p>It goes without saying, but:</p>
            <ul>
              <li>Don't use a password you've used somewhere else.</li>
              <li>Use a password manager to remember all your <i>different</i> passwords, like a book or <a
                href='https://1password.com/'>1Password</a>.
              </li>
            </ul>
            <p>Passwords must be between 8 and 72 characters.</p>
          </Alert>
        </Form>)
      }
    </Page>
  );

}